import { GridInitialState } from "@mui/x-data-grid-pro";
import { FlattenedAavoGridColDef } from "src/components/common/dataGrid/types.tsx";

export function getInitialStateWithMobileColumnDefaults<RowData extends object>(
	initialState: GridInitialState,
	columns: FlattenedAavoGridColDef<RowData>[],
	useListView: boolean,
): GridInitialState {
	if (!useListView) return initialState;

	const currentModel = initialState.columns?.columnVisibilityModel ?? {};
	const mergedModel = { ...currentModel };

	columns.forEach((column) => {
		if (column.field in mergedModel) return;
		mergedModel[column.field] = column.mobile === "cell";
	});

	return {
		...initialState,
		columns: {
			...initialState.columns,
			columnVisibilityModel: mergedModel,
		},
	};
}
